/**
 * Shared DOM markers for portaled UI rendered on behalf of a {@link MiniModal}.
 */

/** Attribute applied to portaled overlays anchored to an open mini-modal. */
export const MINI_MODAL_ANCHORED_OVERLAY_ATTRIBUTE = "data-mini-modal-anchored-overlay";

/** Selector matching {@link MINI_MODAL_ANCHORED_OVERLAY_ATTRIBUTE}. */
export const MINI_MODAL_ANCHORED_OVERLAY_SELECTOR = `[${ MINI_MODAL_ANCHORED_OVERLAY_ATTRIBUTE }="true"]`;

/** JSX spread props marking a portaled overlay root. */
export const miniModalAnchoredOverlayRootProps = { [MINI_MODAL_ANCHORED_OVERLAY_ATTRIBUTE]: "true" } as const;

/**
 * Returns whether a DOM node belongs to a portaled mini-modal overlay.
 *
 * @param node Event target or descendant candidate.
 * @returns `true` when the node is inside an anchored overlay root.
 */
export const isMiniModalAnchoredOverlayNode = ( node: Node ): boolean => {
    if ( !( node instanceof Element ) ) {
        return false;
    }

    return node.closest( MINI_MODAL_ANCHORED_OVERLAY_SELECTOR ) !== null;
};
